/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontHead_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_user">;
    readonly " $refType": "StorefrontHead_user";
};
export type StorefrontHead_user$data = StorefrontHead_user;
export type StorefrontHead_user$key = {
    readonly " $data"?: StorefrontHead_user$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHead_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontHead_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_user",
      "args": null
    }
  ]
};
(node as any).hash = 'be37b972407a12aa7fb1298dc9b08296';
export default node;
